import { useContext, useEffect, useState } from "react";
import { LangContext } from "../../context/LangContext";
import { useToEmbed } from "../../hooks/useToEmbed";
import { useInsertBoldTag } from "../../hooks/useInsertBoldTag";
import SelectLang from "../../components/SelectLang";
import Slider from '../../components/Slider';
import Onglet from "../../components/Onglet";
import Video from "../../components/Video";
import "./style.css"

function VanRah() {
    const toEmbed = useToEmbed();
    const insertBoldTag = useInsertBoldTag();
    const [formData, setFormData] = useState(null);
    const [inSubmit, setInSubmit] = useState(false);

    const { language, translations } = useContext(LangContext);

    localStorage.setItem('opt_return_work_pg_vanrah', 'vanrah');

    useEffect(() => {
        const fetchVanrahData = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/vanrah/profile`);
            const res = await req.json();

            if (req.status !== 200) alert(res.message);

            setFormData({
                logo: res.logo || null,
                descrip_fr: res.descrip_fr || '',
                descrip_en: res.descrip_en || '',
                images: res.images || [],
                series: res.series || [],
                video: res.video.length === 0 ? [''] : res.video
            });
        }
        fetchVanrahData();
    }, []);

    const getPath = (work) => {
        const page_path = work.type === 1 ? 'manga' : 'work';
        return `${page_path}/${work.title_path}`;
    }

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (!file) return

        const url = URL.createObjectURL(file);

        setFormData({
            ...formData,
            logo: { url, file }
        });
    }

    const setValue = (e, field) => {
        setFormData({
            ...formData,
            [field]: e.target.value
        })
    }

    const updateVanrah = async (e) => {
        e.preventDefault();

        if (inSubmit) return alert("Chargement en cours, veuillez patienter");
        else setInSubmit(true);

        const body = new FormData();

        const video = formData.video.filter(v => v !== '').map(v => toEmbed(v));
        body.append('video', JSON.stringify(video));

        body.append('descrip_fr', formData.descrip_fr);
        body.append('descrip_en', formData.descrip_en);

        // Gestion du logo
        if (formData.logo && formData.logo.file) {
            body.append('logo', formData.logo.file);
        }

        // Gestion des images principales
        if (formData.images && Array.isArray(formData.images)) {
            // Envoyer d'abord l'ordre des images
            body.append('images_order', JSON.stringify(formData.images.map(img => ({
                type: img.file ? 'new' : 'existing',
                url: img.url || null,
                _url: img._url || null
            }))));

            // Ensuite envoyer les images
            formData.images.forEach((img, index) => {
                if (img.url && !img.file) {
                    // Image existante
                    body.append(`existing_images[${index}][url]`, img.url);
                    body.append(`existing_images[${index}][_url]`, img._url);
                }
                else if (img.file) {
                    // Nouvelle image
                    body.append('images', img.file);
                }
            });
        }

        const req = await fetch(`${process.env.REACT_APP_API_URL}/vanrah/edit`, {
            method: 'PUT',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token_vanrah')}` },
            body: body
        });
        const res = await req.json();
        setInSubmit(false);

        if (req.status !== 200) {
            alert(res.message);
            return
        }
        alert("Le profil a bien été mis à jour");
        setFormData(res);
    }

    return formData && (
        <form
            onSubmit={updateVanrah}
            className='page page_vanrah'
        >
            <SelectLang />

            <section className="sect_slider_descrip">
                <Slider images={formData.images} setImages={setFormData} />

                <div className="description">
                    <p className='title_page'>
                        - <span>VanRah</span> -
                    </p>

                    <div
                        className="logo"
                        style={{ backgroundImage: `url(${formData?.logo.url})` }}
                    >
                        <input
                            type="file"
                            onChange={(e) => handleFile(e)}
                        />
                    </div>

                    <div className="textarea">
                        <span className="label">{translations.author_presentation} :</span>

                        <div className="toolbar">
                            <button
                                type="button"
                                onClick={() => insertBoldTag('.page_vanrah', formData, setFormData, language)}
                            >Gras</button>
                        </div>

                        <textarea
                            className="value"
                            value={formData[`descrip_${language}`]}
                            onChange={(e) => setValue(e, `descrip_${language}`)}
                            placeholder={`Description de la page en ${language === "fr" ? '"Français"' : '"Anglais"'}`}
                        ></textarea>
                    </div>
                </div>
            </section>

            <section className="sect_published_series">
                <p className="subtitle_page">
                    - <span>{translations.published_series}</span> -
                </p>

                <ul className="published_series_list">
                    {formData.series && formData.series.map((work, idx) => (
                        <li key={idx} className="li_serie">
                            <Onglet data={work} idx={idx} getPath={getPath} />
                        </li>
                    ))}
                </ul>
            </section>

            <section className="sect_artist_univers">
                <p className="subtitle_page">
                    - <span>{translations.discover_artist}</span> -
                </p>

                {formData.video.map((v, idx) => <Video key={1} data={formData} counter={idx} setData={setFormData} />)}
            </section>

            <div className="panel_form">
                <button
                    type="submit"
                    className="btn_submit"
                >modifier</button>
            </div>
        </form>
    )
}

export default VanRah;